export const getDisplayText = (value: string) => {
  const source = value.startsWith("OWS_") ? "OWS" : "OTA";
  const baseValue = value.startsWith("OWS_") ? value.substring(4) : value;

  switch (baseValue) {
    case "BB":
      return `[${source}] 2 Pax BB`;
    case "RO":
      return `[${source}] 2 Pax RO`;
    case "oneGuestRO":
      return `[${source}] 1 Pax RO`;
    case "oneGuestBB":
      return `[${source}] 1 Pax BB`;
    default:
      return value;
  }
};

export interface ContextMenuItem {
  name: string;
  key?: string;
  callback?: (name: string, selection: any, clickEvent: any) => void;
  disabled: () => boolean;
  hidden: () => boolean;
  isCommand?: boolean;
  submenu?: ContextMenuItem[];
}

type GuestOption = {
  display: string;
  value: string;
};

const createSubMenuItem = (
  displayName: string,
  value: string,
  onSelect: (value: string) => void,
): ContextMenuItem => ({
  name: displayName,
  key: `ota-${value}`,
  callback: (_name: string, _selection: any, _clickEvent: any): void => {
    onSelect(value);
  },
  disabled: () => false,
  hidden: () => false,
});

export function getOTAMenuItem(
  onSelect: (value: string) => void,
  isOWSEnabled: boolean,
): ContextMenuItem {
  const otaOptions: GuestOption[] = [
    { display: "[OTA] 1 Pax RO", value: "oneGuestRO" },
    { display: "[OTA] 1 Pax BB", value: "oneGuestBB" },
    { display: "[OTA] 2 Pax RO", value: "RO" },
    { display: "[OTA] 2 Pax BB", value: "BB" },
  ];

  const owsOptions: GuestOption[] = [
    { display: "[OWS] 1 Pax RO", value: "OWS_oneGuestRO" },
    { display: "[OWS] 1 Pax BB", value: "OWS_oneGuestBB" },
    { display: "[OWS] 2 Pax RO", value: "OWS_RO" },
    { display: "[OWS] 2 Pax BB", value: "OWS_BB" },
  ];

  return {
    key: "OTAMenu",
    name: "Channel Options",
    disabled: () => false,
    hidden: () => false,
    submenu: [
      {
        name: "OTA",
        key: "ota-submenu",
        disabled: () => false,
        hidden: () => false,
        submenu: otaOptions.map((opt) =>
          createSubMenuItem(opt.display, opt.value, onSelect),
        ),
      },
      ...(isOWSEnabled
        ? [
            {
              name: "OWS",
              key: "ows-submenu",
              disabled: () => false,
              hidden: () => false,
              submenu: owsOptions.map((opt) =>
                createSubMenuItem(opt.display, opt.value, onSelect),
              ),
            },
          ]
        : []),
    ],
  };
}
